export enum IncomingDeliveryListTabsEnum {
  PENDING= 'pending',
  RECEIVED= 'received',
  WAREHOUSED= 'warehoused',
}
